import $ from 'jquery'
import swal from 'sweetalert2'
import commonMixin from './mixins/common'
import eventBus from './eventBus'
import PartialAccount from './StepSummary/Account'
import PartialApplicant from './StepSummary/Applicant'
import PartialCoapplicant from './StepSummary/Coapplicant'
import PartialService from './StepSummary/Service'

export default {
  mixins: [commonMixin],

  components: {
    PartialAccount,
    PartialApplicant,
    PartialCoapplicant,
    PartialService,
  },

  // language=HTML (for PhpStorm)
  template: `
    <ui-form
      label-position="left"
      :label-columns="3"
      :input-columns="9"
    >
      <template v-if="finished">
        <p class="success callout">
          Thank you for completing this online service application. An Office Service
          Representative will be in contact with you to confirm your application has
          been processed & to discuss deposit options, if applicable. Please make yourself
          familiar with Rutherford EMC’s policies and procedures by reading over the
          New Member Packet and Service Rules and Regulations, which can be found under
          the “About Us” tab on our homepage.
        </p>
      </template>
      <template v-else>
        <p style="font-weight: bold" class="alert callout">
          Please confirm your information and click the “Finish” button.
          If you find anything to be incorrect, click on the “Edit” button.
        </p>

        <PartialAccount :model="model" />
        <PartialApplicant :model="model" />
        <PartialCoapplicant :model="model" v-if="model.account.ownership === 'Joint'" />
        <PartialService :model="model" />

        <p class="service-app-finish-wrapper">
          <button
            type="button"
            class="large primary button"
            :disabled="finishing"
            @click="finish"
          >
            Finish
          </button>
          <ui-progress-circular v-show="finishing" :size="17" :indeterminate="true" />

          <button
            v-show="!finishing"
            type="button"
            class="large transparent button"
            style="margin-left: 1rem"
            @click="goBack"
          >
            Edit
          </button>
        </p>
      </template>
    </ui-form>
  `,

  props: {
    saveUrl: String,
    model: Object,
    validationRules: Object,
  },

  data() {
    return {
      finished: false,
      finishing: false,
    }
  },

  methods: {
    goBack() {
      eventBus.$emit('prev-step')
    },

    finish() {
      this.finishing = true

      if (this.finishXhr) {
        this.finishXhr.abort()
      }

      this.finishXhr = $.ajax({
        type: 'POST',
        url: this.saveUrl,
        data: this.model,
        dataType: 'json',
      })
        .always(() => {
          this.finishing = false
        })
        .done((resp) => {
          if ('error' in resp) {
            swal('Error', resp.error, 'error')
            return
          }

          this.finished = true
        })
    },
  },

  created() {
    this.finishXhr = null
  },
}
